import { defineMessages } from 'react-intl';

export default defineMessages({
    removeActionLabel: {
        id: 'quoteandbind.RecVehProduct.views.coverables.RemoveActionLabel',
        defaultMessage: 'Delete'
    }
    // add string ids and default values for localization here
});
